module.exports = __webpack_public_path__ + "static/media/drivers.1b321d22.svg";